module.exports = __webpack_public_path__ + "img/otto.a6bc6948.jpg";